import JobsServices from "@services/jobs.services"
import CareerDetailPage from "@modules/career-detail/CareerDetailPage"
import { GetServerSideProps, GetServerSidePropsContext } from "next"
import { Job } from "@interfaces/career"

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const jobDetail = new JobsServices()

  const { category_id, position_id } = context.query

  try {
    const res = await jobDetail.getJobDetail({
      category_id: category_id,
      position_id: position_id,
    })

    let data: Job

    if (res.isSuccess) {
      data = res.getValue()
      return {
        props: {
          data,
        },
      }
    }
    return {
      props: {},
    }
  } catch (e) {
    console.log(e)

    return {
      props: {},
    }
  }
}

export default CareerDetailPage
